import { Children } from 'react';
import set from 'lodash/set';
import { isString } from '../form/formUtilities';

export const resolveDisplayName = (columnProps) => {
  const { id, displayName, children } = columnProps;
  const names = Children.toArray(children).filter(o => o).filter(isString);
  let name = id;
  if (displayName) {
    name = displayName;
  } else if (names.length) {
    [name] = names;
  }
  return name;
};


export const resolveErrors = (errorData) => {
  const es = {};
  Object.entries(errorData.formErrors)
    .forEach(([field, errors]) => {
      const e = errors[0];
      set(es, field, e);
    });
  return es;
};
